<template>
    <div class="login-page">
        <div class="login-wrapper" v-on:keyup.enter="handleLogin">
            <div class="rainbow-bar"></div>
            <ion-title>{{ $t('master.login') }}</ion-title>
            <p class="error-message">{{ error }}</p>
            <text-box
                class="email"
                transparent="true"
                :label="$t('master.usernameOrEmail')"
                inputType="email"
                @onChange="handleEmailChange"
                :error="errors['usernameOrEmail']"
            />
            <text-box
                class="password"
                transparent="true"
                :label="$t('master.password')"
                inputType="password"
                @onChange="handlePasswordChange"
                :error="errors['password']"
            />
            <div class="forgot-password-wrapper ion-text-start">
                <ion-text class="forgot-password ion-padding-start" color="primary" @click="$router.push('forgot-password')">{{
                    $t('master.forgotPassword')
                }}</ion-text>
            </div>
            <div class="ion-margin-vertical buttons-wrapper">
                <ion-button
                    @click="handleLogin"
                    shape="round"
                    class="login-button ion-float-start ion-no-margin ion-padding-vertical"
                    color="primary"
                    strong
                >
                    <ion-text>{{ $t('master.login') }}</ion-text>
                </ion-button>
                <ion-button
                    @click="goToSignup"
                    shape="round"
                    class="signup-button ion-float-end ion-no-margin ion-padding-vertical"
                    color="secondary"
                    strong
                >
                    <ion-text>{{ $t('master.signup') }}</ion-text>
                </ion-button>
            </div>
        </div>
        <ion-row class="other-logins">
            <ion-col size-xs="12" size-sm="12" size-md="6" class="login-fb ion-no-padding">
                <img
                    @click="handleSocialLogin('facebook')"
                    :src="
                        $i18n.locale == 'ar'
                            ? require('@/assets/login-fb-ar.png')
                            : isMobile || windowWidth < 1200
                            ? require('@/assets/login-fb.png')
                            : require('@/assets/signup-fb.png')
                    "
                />
            </ion-col>

            <ion-col size-xs="12" size-sm="12" size-md="6" class="login-google ion-no-margin ion-no-padding">
                <img
                    @click="handleSocialLogin('google')"
                    :src="
                        $i18n.locale == 'ar'
                            ? require('@/assets/login-google-ar.png')
                            : isMobile || windowWidth < 1200
                            ? require('@/assets/login-google.png')
                            : require('@/assets/signup-google.png')
                    "
                />
            </ion-col>

            <ion-col v-if="showAttach" size-xs="12" size-sm="12" size-md="6" class="login-apple ion-no-margin ion-no-padding">
                <img @click="handleSocialLogin('apple')" :src="require('@/assets/login-apple.png')" />
            </ion-col>
        </ion-row>
    </div>
</template>

<script>
// @ is an alias to /src
import TextBox from '@/components/TextBox'
import { validateLogin } from '@/utils/validators.js'
import { constants } from '../../constants'
import { mapGetters } from 'vuex'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'home',
    computed: mapGetters(['lang']),
    data() {
        return {
            usernameOrEmail: '',
            password: '',
            errors: [],
            error: '',
            constants,
            isMobile,
            showAttach: process.env.CORDOVA_PLATFORM === 'ios'
        }
    },
    components: {
        TextBox
    },
    methods: {
        handleLogin() {
            this.errors = []
            this.error = ''
            const { error } = validateLogin({
                usernameOrEmail: this.usernameOrEmail,
                password: this.password
            })

            if (error) {
                error.details.forEach(err => {
                    this.$set(this.errors, err.path[0], err.message)
                })
                return
            }
            this.$store.dispatch('login', {
                usernameOrEmail: this.usernameOrEmail,
                password: this.password
            })
        },
        handleSocialLogin(provider) {
            if (constants.platform == 'desktop') {
                this.$auth.authenticate(provider).then(response => {
                    const { code } = response
                    this.$store.dispatch('socialLogin', { lang: this.lang, mode: 'web', provider, code })
                })
            } else {
                if (provider === 'google') {
                    const self = this
                    window.plugins.googleplus.login(
                        {
                            scopes: 'profile email' // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
                            //webClientId: '45183497377-689grf7t5rrjo0mu1th68q4hl4lja5tp.apps.googleusercontent.com' // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
                            // offline: true // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
                        },
                        function(obj) {
                            const code = obj.accessToken
                            self.$store.dispatch('socialLogin', { lang: self.lang, mode: 'device', provider, code })
                        },
                        function(msg) {
                            console.log('error: ' + msg)
                        }
                    )
                }
                if (provider === 'facebook') {
                    const self = this
                    try {
                        facebookConnectPlugin.login(
                            ['public_profile', 'email'],
                            function(response) {
                                const code = response.authResponse.accessToken
                                self.$store.dispatch('socialLogin', { lang: self.lang, mode: 'device', provider, code })
                            },
                            function(error) {
                                console.log(error)
                            }
                        )
                    } catch (ex) {
                        alert(ex)
                    }
                }
                if (provider === 'apple') {
                    const self = this
                    try {
                        window.cordova.plugins.SignInWithApple.signin(
                            { requestedScopes: [0, 1] },
                            function(response) {
                                const code = response.authorizationCode
                                const token = response.identityToken
                                const email = response.email
                                const { givenName, familyName } = response.fullName
                                self.$store.dispatch('appleLogin', { lang: self.lang, code, email, givenName, familyName })
                            },
                            function(err) {
                                alert(JSON.stringify(err))
                            }
                        )
                    } catch (ex) {
                        alert(ex)
                    }
                }
            }
        },
        goToSignup() {
            this.$router.push('/register/step-1')
        },
        handleEmailChange(value) {
            this.usernameOrEmail = value
        },
        handlePasswordChange(value) {
            this.password = value
        }
    }
}
</script>
<style lang="scss" scoped>
.login-page {
    position: relative;
    background-image: url('~@/assets/login-bg-mobile.png');
    background-size: cover;
    width: 100%;
    height: 100%;
    padding: 5% 10% 0 10%;
}

.login-apple {
    text-align: center;
    padding: 0 1%;
}

.login-apple img {
    width: 100%;
}

.buttons-wrapper {
    position: absolute;
    bottom: -15px;
    margin: 0;
    width: 106%;
    left: -3%;
    height: 50px;
    .login-button {
        height: 75px;
        --border-radius: 25px 0 0 25px;
    }

    .signup-button {
        height: 75px;
        --border-radius: 0 25px 25px 0;
    }
}

#app[dir='rtl'] .buttons-wrapper {
    .login-button {
        --border-radius: 0 25px 25px 0;
    }

    .signup-button {
        --border-radius: 25px 0 0 25px;
    }
}

ion-title {
    position: relative;
    font-size: 120%;
}

ion-button {
    position: relative;
    bottom: 0;
    width: 50%;
}

.m-10 {
    margin: 10px;
}

.m-v-20 {
    margin-top: 20px;
    margin-bottom: 20px;
}

.login-wrapper {
    padding: 5% 5% 25% 5%;
    background-color: rgba(255, 255, 255, 0.8);
    position: relative;
}

.forgot-password {
    cursor: pointer;
    font-size: 70%;
    position: relative;
    top: 10px;
}

.forgot-password-wrapper {
    padding-bottom: 50px;
}

.rainbow-bar {
    display: inline-block;
    position: absolute;
    z-index: 1000000;
    width: 100%;
    top: 0;
    left: 0px;
    background: rgba(221, 212, 191, 1);
    background: -moz-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );

    background: -webkit-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: -o-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: -ms-linear-gradient(
        left,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    background: linear-gradient(
        to right,
        rgba(221, 212, 191, 1) 0%,
        rgba(221, 212, 191, 1) 20%,
        rgba(180, 199, 174, 1) 20%,
        rgba(180, 199, 174, 1) 40%,
        rgba(124, 193, 139, 1) 40%,
        rgba(124, 193, 139, 1) 60%,
        rgba(24, 134, 101, 1) 60%,
        rgba(24, 134, 101, 1) 80%,
        rgba(16, 69, 87, 1) 80%,
        rgba(16, 69, 87, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ddd4bf', endColorstr='#104557', GradientType=1 );
    height: 5px;
}

.other-logins {
    position: relative;
    top: 50px;

    img {
        width: 90%;
    }
}

@media (min-width: 768px) {
    .login-page {
        padding: 10% 15% 0 15%;
        background-size: 100% 100%;

        .login-wrapper {
            padding-bottom: 50px;
            padding-top: 10px;
        }

        ion-title {
            font-size: 180%;
            margin-bottom: 30px;
        }

        .login-button,
        .signup-button {
            font-size: 25px;
            height: 100px;
        }

        .login-button {
            border-radius: 40px 0 0 40px;
        }

        .signup-button {
            border-radius: 0 40px 40px 0;
        }

        .other-logins {
            width: 130%;
            top: 150px;
            left: -15%;
            right: -15%;
        }

        .forgot-password {
            font-size: 18px;
            top: 20px;
        }

        .email,
        .password {
            margin-bottom: 20px;
            font-size: 25px;
        }
    }

    #app[dir='rtl'] .buttons-wrapper {
        .login-button {
            --border-radius: 0 40px 40px 0;
        }

        .signup-button {
            --border-radius: 40px 0 0 40px;
        }
    }
}

@media (min-width: 1200px) {
    .login-page {
        padding: 5% 20% 10% 20%;
    }

    .login-wrapper {
        width: 40%;
        margin: 0 auto;
    }

    .other-logins {
        width: 80% !important;
        margin: 0 auto;
        top: auto !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 5%;
        position: absolute !important;

        .login-fb img,
        .login-google img {
            width: 40%;
        }
        .login-fb {
            text-align: end;
            padding: 0 3%;
        }
        .login-google {
            text-align: start;
            padding: 0 3%;
        }
    }
    .email,
    .password {
        margin-bottom: 0 !important;
        font-size: 20px !important;
    }

    ion-title {
        font-size: 150% !important;
        margin-bottom: 10px !important;
    }

    .login-button,
    .signup-button {
        font-size: 20px !important;
        height: 80px !important;
    }
}
</style>
